<template>
  <div class="detail" :class="{ last: isLast }">
    <div class="img-box">
      <img :src="require(`../../../../assets/${afterDescription.logo || 'CODE'}.png`)" alt="" />
    </div>
    <div class="info-box">
      <div class="top">
        <div class="title">{{ afterDescription.actionType }}</div>
        <div class="time">{{ afterDescription.doneTime }}</div>
        <div class="name">{{ afterDescription.userName }}</div>
      </div>
      <div class="bottom" v-if="typeof afterDescription.bottomContent === 'string'">
        {{ afterDescription && afterDescription.bottomContent }}
      </div>
      <div class="bottom" v-if="typeof afterDescription.bottomContent === 'object'">
        <div>{{ afterDescription.bottomContent.companyName }}</div>
        <img src="../../../../assets/right.webp" alt="" v-if="
          afterDescription.bottomContent.tenantName !== null ||
          afterDescription.bottomContent.whName !== null
        " />
        <div>{{ afterDescription.bottomContent.tenantName }}</div>
        <img src="../../../../assets/right.webp" alt="" v-if="
          afterDescription.bottomContent.tenantName !== null &&
          afterDescription.bottomContent.whName !== null
        " />
        <div>{{ afterDescription.bottomContent.whName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: Object,
      default: () => { },
    },
    isLast: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      showIt: true,
      descByActionType: {},
      afterDescription: {},
    };
  },

  created() {
    this.handleAction();
    this.afterDescription = this.description;

    this.descByActionType[this.afterDescription.actionType]();
    console.log(typeof this.afterDescription.bottomContent);
  },

  methods: {
    handleAction() {
      const that = this;
      this.descByActionType = {
        客户: function () {
          that.afterDescription.bottomContent = that.afterDescription.userPhone;
        },
        生产: function () {
          that.afterDescription.bottomContent = that.afterDescription.orgName;
        },
        销售: function () {
          that.afterDescription.bottomContent = that.afterDescription.orgName;
          that.afterDescription.logo = 'SALES';
        },
        出库: function () {
          that.afterDescription.bottomContent = that.afterDescription.tenantVO;
        },
        入库: function () {
          that.afterDescription.bottomContent = that.afterDescription.tenantVO;
        },
        质检: function () {
          that.afterDescription.bottomContent = that.afterDescription.orgName;
          that.afterDescription.logo = 'QUALITY';
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  position: relative;
  padding-bottom: 24px;
  min-height: 93px;

  &:before {
    content: "";
    position: absolute;
    left: 24px;
    top: 0;
    width: 0px;
    height: 100%;
    border-left: 1px dashed #e2e4ea;
  }

  &.last:before {
    display: none;
  }

  .img-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 48px;
    height: 48px;

    >img {
      width: 100%;
      height: 100%;
    }
  }

  .info-box {
    margin-left: 56px;
    padding: 24px 32px 24px 24px;
    background: #FAFAFA;
    color: #666;
    border-radius: 8px;
  }

  .top {
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    color: #333;

    .title {
      font-size: 28px;
      font-weight: bold;
    }

    .name {
      font-size: 26px;
    }

    .time {
      color: #999;
      font-size: 22px;
    }
  }

  .bottom {
    margin-top: 16px;
    font-size: 26px;
    line-height: 36px;
    display: flex;
    align-items: center;

    >img {
      width: 32px;
      height: 32px;
    }

    >div {
      color: #333333;
      font-size: 28px;
    }
  }
}
</style>
